import { useMemo } from 'react'
import {
  TYPEAHEAD_GEO_TYPE_INDEXED_ROLLOUT_FLAGS,
  TYPEAHEAD_NOSPACE_SEARCH_ROLLOUT_FLAGS,
  TYPEAHEAD_REALTIME_EXTRACTION_ROLLOUT_FLAGS,
} from 'constants/search'
import { EmptyArray } from 'lib/array/arrayUtils'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyFeatureFlags } from 'constants/optimizely'

/**
 * Builds the typeahead rollout flags array from the feature flags that
 * gate real-time extraction, no-space search, and geo-type-indexed search.
 * Reads Optimizely flags internally so callers don't need to manage them.
 * Returns a stable EmptyArray reference when no flags are active.
 */
function useTypeaheadRollout(): Array<string> {
  const isRealTimeDateAndOccupancyExtractionEnabled = !!useOptimizelyExperiment(OptimizelyFeatureFlags.searchRealTimeDateAndOccupancyExtraction)
  const isTypeaheadNospaceMatchEnabled = !!useOptimizelyExperiment(OptimizelyFeatureFlags.searchTypeaheadNospaceMatch)
  const isTypeaheadGeoTypeIndexedEnabled = !!useOptimizelyExperiment(OptimizelyFeatureFlags.searchTypeaheadGeoTypeIndexed)

  return useMemo(() => {
    const flags: Array<string> = [
      ...(isRealTimeDateAndOccupancyExtractionEnabled ? TYPEAHEAD_REALTIME_EXTRACTION_ROLLOUT_FLAGS : []),
      ...(isTypeaheadNospaceMatchEnabled ? TYPEAHEAD_NOSPACE_SEARCH_ROLLOUT_FLAGS : []),
      ...(isTypeaheadGeoTypeIndexedEnabled ? TYPEAHEAD_GEO_TYPE_INDEXED_ROLLOUT_FLAGS : []),
    ]
    return flags.length > 0 ? flags : EmptyArray
  }, [isRealTimeDateAndOccupancyExtractionEnabled, isTypeaheadNospaceMatchEnabled, isTypeaheadGeoTypeIndexedEnabled])
}

export default useTypeaheadRollout
